import { defineComponent, createElementBlock, openBlock, createElementVNode, Fragment, renderList, normalizeClass, createBlock, createCommentVNode, toDisplayString, withCtx, createTextVNode } from 'vue';
import _sfc_main$1 from './basler-components.es79.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es121.js';
import _sfc_main$3 from './basler-components.es68.js';
/* empty css                       */

const _hoisted_1 = { class: "nav-action-bar" };
const _hoisted_2 = { class: "nav-action-bar__list" };
const _hoisted_3 = ["aria-expanded"];
const _hoisted_4 = { class: "visually-hidden" };
const _hoisted_5 = { class: "visually-hidden" };
const _hoisted_6 = {
  key: 1,
  class: "nav-action-bar__user-box",
  "aria-hidden": "true"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NavActionBar",
  props: {
    items: {},
    searchIsOpen: { type: Boolean }
  },
  emits: ["search-toggle", "link-hover"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const onSearchToggle = () => {
      emit("search-toggle", !props.searchIsOpen);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", _hoisted_1, [
        createElementVNode("ul", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
            return openBlock(), createElementBlock("li", {
              key: `${item.title}-${index}`,
              class: normalizeClass(["nav-action-bar__list-item", `nav-action-bar__list-item--${item.type}`])
            }, [
              item.type === "search" ? (openBlock(), createElementBlock("button", {
                key: 0,
                class: "nav-action-bar__element",
                "aria-expanded": _ctx.searchIsOpen,
                onClick: onSearchToggle
              }, [
                createElementVNode("span", _hoisted_4, toDisplayString(item.title), 1),
                item.iconName ? (openBlock(), createBlock(_sfc_main$1, {
                  key: 0,
                  name: item.iconName,
                  size: "large",
                  "aria-hidden": "true"
                }, null, 8, ["name"])) : createCommentVNode("", true)
              ], 8, _hoisted_3)) : (openBlock(), createBlock(_sfc_main$2, {
                key: 1,
                class: normalizeClass(["nav-action-bar__element", { "is-active": item.isActive }]),
                uri: item.link.uri,
                rel: item.link.rel,
                target: item.link.target,
                onMouseenter: ($event) => emit("link-hover", item.type, true, $event),
                onMouseleave: ($event) => emit("link-hover", item.type, false, $event)
              }, {
                default: withCtx(() => [
                  createElementVNode("span", _hoisted_5, toDisplayString(item.title), 1),
                  item.iconName ? (openBlock(), createBlock(_sfc_main$1, {
                    key: 0,
                    name: item.iconName,
                    size: "large",
                    "aria-hidden": "true"
                  }, null, 8, ["name"])) : createCommentVNode("", true),
                  item.userInitials ? (openBlock(), createElementBlock("span", _hoisted_6, toDisplayString(item.userInitials), 1)) : createCommentVNode("", true),
                  item.badgeNumber ? (openBlock(), createBlock(_sfc_main$3, {
                    key: 2,
                    "is-round": true,
                    size: "xsmall",
                    class: "nav-action-bar__badge"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.badgeNumber), 1)
                    ]),
                    _: 2
                  }, 1024)) : createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["class", "uri", "rel", "target", "onMouseenter", "onMouseleave"]))
            ], 2);
          }), 128))
        ])
      ]);
    };
  }
});

export { _sfc_main as default };
